import { ReportMedia } from "@shared/lib/types/reports";
import { Button, Modal } from "@shared/ui";
import { Close } from "@shared/ui/icons";
import styles from "./styles.module.scss";

type NonTrackableLinksModalProps = {
  open: boolean;
  onClose: () => void;
  nonTrackableLinks: ReportMedia[];
};

function getCreatorName(media: ReportMedia): string {
  return (
    media.socialMedia?.searchV1?.fullName ||
    media.username ||
    media.socialMedia?.username ||
    ""
  );
}

export function NonTrackableLinksModal({
  open,
  onClose,
  nonTrackableLinks,
}: NonTrackableLinksModalProps) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={null}
      footer={null}
      closable={false}
      width={576}
      className={styles.modal}
    >
      <div className={styles.modalHeader}>
        <div>
          <h3 className={styles.modalTitle}>Non-trackable Links</h3>
          <p className={styles.modalSubtitle}>
            Only valid Instagram/YouTube post links can be tracked.
          </p>
        </div>
        <button
          type="button"
          onClick={onClose}
          className={styles.closeButton}
          aria-label="Close"
        >
          <Close />
        </button>
      </div>
      <div className={styles.modalBody}>
        {nonTrackableLinks.map((item) => (
          <div key={item._id} className={styles.linkItem}>
            <div className={styles.linkItemHeader}>
              <span className={styles.creatorName}>{getCreatorName(item)}</span>
              {(item.platform || item.socialMedia?.platform) && (
                <span className={styles.platformBadge}>
                  {item.platform || item.socialMedia?.platform || "—"}
                </span>
              )}
            </div>
            <a
              href={item.link}
              target="_blank"
              rel="noreferrer"
              className={styles.linkUrl}
            >
              {item.link}
            </a>
            {item.nonTrackableReason && (
              <p className={styles.reason}>{item.nonTrackableReason}</p>
            )}
          </div>
        ))}
      </div>
      <div className={styles.modalFooter}>
        <Button type="primary" onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
}
